import { L, vocabulary } from '../define.js';
export const CENTRAL_DESK_VOCABULARIES = [
    vocabulary('central_desk.operator_recipient', '@vello/central-desk OPERATOR_RECIPIENTS', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        both: L('Passageiro e motorista', 'Rider and driver', 'Pasajero y conductor', 'Passeggero e autista'),
    }),
    vocabulary('central_desk.central_order_status', '@vello/central-desk CENTRAL_ORDER_STATUSES', {
        CONSENT_PENDING: L('Aguardando consentimento', 'Awaiting consent', 'Esperando consentimiento', 'In attesa di consenso'),
        REQUESTED: L('Corrida pedida', 'Ride requested', 'Viaje solicitado', 'Corsa richiesta'),
        EXPIRED: L('Expirado', 'Expired', 'Vencido', 'Scaduto'),
        CANCELLED: L('Cancelado', 'Cancelled', 'Cancelado', 'Annullato'),
    }),
    vocabulary('central_desk.courier_incident_resolution', '@vello/central-desk COURIER_INCIDENT_RESOLUTIONS', {
        resumed: L('Entrega retomada', 'Delivery resumed', 'Entrega reanudada', 'Consegna ripresa'),
        courier_released: L('Entregador liberado', 'Courier released', 'Repartidor liberado', 'Corriere liberato'),
        order_cancelled: L('Pedido cancelado', 'Order cancelled', 'Pedido cancelado', 'Ordine annullato'),
        dismissed: L('Ocorrência descartada', 'Incident dismissed', 'Incidencia descartada', 'Segnalazione scartata'),
    }),
    vocabulary('central_desk.courier_incident_code', '@vello/central-desk COURIER_INCIDENT_CODES', {
        store_closed: L('Loja fechada', 'Store closed', 'Tienda cerrada', 'Negozio chiuso'),
        recipient_absent: L('Destinatário ausente', 'Recipient absent', 'Destinatario ausente', 'Destinatario assente'),
        courier_cancel: L('Entregador quer cancelar', 'Courier wants to cancel', 'El repartidor quiere cancelar', 'Il corriere vuole annullare'),
    }),
    vocabulary('central_desk.chat_sender_role', '@vello/central-desk CHAT_SENDER_ROLES', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        operator: L('Central', 'Central', 'Central', 'Centrale'),
    }),
    vocabulary('central_desk.chat_recipient', '@vello/central-desk CHAT_RECIPIENTS', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        both: L('Passageiro e motorista', 'Rider and driver', 'Pasajero y conductor', 'Passeggero e autista'),
        operator: L('Central', 'Central', 'Central', 'Centrale'),
    }),
    vocabulary('central_desk.consent_status', '@vello/central-desk CONSENT_STATUSES', {
        PENDING: L('Aguardando código', 'Awaiting code', 'Esperando código', 'In attesa del codice'),
        VERIFIED: L('Consentimento confirmado', 'Consent confirmed', 'Consentimiento confirmado', 'Consenso confermato'),
        EXPIRED: L('Código expirado', 'Code expired', 'Código vencido', 'Codice scaduto'),
        LOCKED: L('Bloqueado por tentativas', 'Locked after attempts', 'Bloqueado por intentos', 'Bloccato per tentativi'),
    }),
    vocabulary('central_desk.consent_verify_reason', '@vello/central-desk CONSENT_VERIFY_REASONS', {
        OK: L('Código confirmado', 'Code confirmed', 'Código confirmado', 'Codice confermato'),
        NOT_PENDING: L('Nenhum código aguardando', 'No code pending', 'Ningún código pendiente', 'Nessun codice in attesa'),
        EXPIRED: L('Código expirado', 'Code expired', 'Código vencido', 'Codice scaduto'),
        TOO_MANY_ATTEMPTS: L('Tentativas demais', 'Too many attempts', 'Demasiados intentos', 'Troppi tentativi'),
        INVALID_CODE: L('Código incorreto', 'Wrong code', 'Código incorrecto', 'Codice errato'),
    }),
    vocabulary('central_desk.courier_incident_status', '@vello/central-desk COURIER_INCIDENT_STATUSES', {
        OPEN: L('Aberta', 'Open', 'Abierta', 'Aperta'),
        RESOLVED: L('Resolvida', 'Resolved', 'Resuelta', 'Risolta'),
    }),
    vocabulary('problem.central_desk', '@vello/central-desk CENTRAL_ORDER_REFUSALS', {
        IDEMPOTENCY_KEY_REUSED: L('Esta chave de repetição já foi usada em outro pedido.', 'This retry key was already used for another order.', 'Esta clave de reintento ya se usó en otro pedido.', 'Questa chiave di ripetizione è già stata usata per un altro ordine.'),
    }, 'message'),
];
//# sourceMappingURL=central-desk.js.map